// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__1BH8j","dark":"Tag_dark__Jd8lh","fadeIn":"Tag_fadeIn__13-gD","scaleXin":"Tag_scaleXin__1xait"};